import RuntimeComponentFactory from '../factory/RuntimeComponentFactory.js';
import {BaseComponent} from '../components/_BaseComponent.js';

class CommonFaq extends BaseComponent {

    constructor(el, componentName) {
        super(el, componentName);

        this.init();
    }

    init = () => {
        let acc = document.getElementsByClassName("faq-question");
        let i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                let panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
    };
}

RuntimeComponentFactory.add('CommonFaq', CommonFaq);
